// apps/frontend/src/lib/pipeline-preview/transformers/destination.ts
import type { PipelineNode, ExecutionContext, TransformerResult } from '../types';
import { inferSchema } from '../utils/schema';

/**
 * DESTINATION Transformer - Pass-through for preview
 * Does NOT actually save to database, just shows final data
 */
export async function destinationData(
  node: PipelineNode,
  inputData: unknown[],
  _context: ExecutionContext
): Promise<TransformerResult> {
  const startTime = performance.now();

  try {
    const config = node.data.config as any;

    // Validate configuration
    if (!config?.destinationId || !config?.tableName || !config?.writeMode) {
      return {
        success: false,
        data: [],
        schema: { columns: [] },
        stats: { rows: 0, executionTime: 0 },
        error: 'Missing destination configuration (destinationId, tableName, or writeMode)',
      };
    }

    // Pass through data unchanged (preview mode)
    const endTime = performance.now();

    return {
      success: true,
      data: inputData,
      schema: inferSchema(inputData),
      stats: {
        rows: inputData.length,
        executionTime: Math.round(endTime - startTime),
      },
    };
  } catch (error: any) {
    const endTime = performance.now();
    return {
      success: false,
      data: [],
      schema: { columns: [] },
      stats: { rows: 0, executionTime: Math.round(endTime - startTime) },
      error: error.message || 'Destination processing failed',
    };
  }
}
